const actions = {
    FETCH_EMAIL_SERVER_INVOICES: 'FETCH_EMAIL_SERVER_INVOICES',
    FETCH_EMAIL_SERVER_INVOICE: 'FETCH_EMAIL_SERVER_INVOICE',
    RESET_EMAIL_SERVER_INVOICE: 'RESET_EMAIL_SERVER_INVOICE',

    fetchEmailServerInvoicesAction: (data) => {
        return {
            type: actions.FETCH_EMAIL_SERVER_INVOICES,
            data: data
        };
    },

    resetEmailServerInvoiceFormAction: () => {
        return {
            type: actions.RESET_EMAIL_SERVER_INVOICE,
            data: null
        };
    },

    fetchEmailServerInvoiceAction: (data) => {
        return {
            type: actions.FETCH_EMAIL_SERVER_INVOICE,
            data: data
        };
    },
};

export default actions;